import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AccountCircle, LockRounded } from '@mui/icons-material';
import PillTabs from 'components/shared/tabs/PillTabs';

// Perfil del cliente: toggle pill (patrón MySchoolUAE) entre Información personal y de
// seguridad. PillTabs conserva la a11y del Tabs de MUI (tabsA11yProps por índice).
function ClientProfileTabs({ currentTab, onTabChange }) {
  const { t } = useTranslation(['labels']);

  return (
    <PillTabs
      value={currentTab}
      onChange={onTabChange}
      centered
      ariaLabel={t('personalInformation', { ns: 'labels' })}
      tabs={[
        {
          key: 'personal',
          icon: <AccountCircle />,
          label: t('personalInformation', { ns: 'labels' })
        },
        {
          key: 'security',
          icon: <LockRounded />,
          label: t('securityInformation', { ns: 'labels' })
        }
      ]}
    />
  );
}

ClientProfileTabs.propTypes = {
  currentTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired
};

export default ClientProfileTabs;
